import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import Tabs, { Tab } from "material-ui/Tabs";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "row"
  },
  tabs: {
    flex: "1 1 auto"
  },
  tabsRoot: {
    minHeight: 36
  },
  tabRoot: {
    height: 36
  }
});

const AccountSubbar = props => {
  const {
    classes,
    match,
    history,
    labels,
    persistTab,
    tabIndex,
    secondaryControl
  } = props;

  const tabs = labels.map((label, i) => (
    <Tab key={i} label={label} classes={{ root: classes.tabRoot }} />
  ));

  const onChangeTab = (event, tabIndex) => {
    const { accountId } = match.params;
    history.push(`/accounts/${accountId}/${labels[tabIndex]}`);
    persistTab(tabIndex);
  };

  return (
    <div className={classes.root}>
      <Tabs
        classes={{
          root: classes.tabsRoot
        }}
        className={classes.tabs}
        value={tabIndex}
        onChange={onChangeTab}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </Tabs>
      {secondaryControl}
    </div>
  );
};
AccountSubbar.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  labels: PropTypes.array.isRequired,
  persistTab: PropTypes.func.isRequired,
  secondaryControl: PropTypes.element
};

export { AccountSubbar };

export default withStyles(styles, { name: "AccountSubbar" })(
  withRouter(AccountSubbar)
);



// WEBPACK FOOTER //
// ./src/AccountSubbar.js